import { a1 as attr } from "./index.js";
import Icon from "./icon3.js";
function Logo($$payload) {
  $$payload.out += `<a href="/" class="flex items-center space-x-2 !text-inherit"><img${attr("src", Icon)} class="w-12 h-12 min-w-12 lg:w-8 lg:h-8 lg:min-w-8" alt="logo"> <span class="text-2xl font-display font-bold hidden lg:flex">Glimmr</span></a>`;
}
export {
  Logo as L
};
